export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5597.8f85c36b.jpg";